import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { property } from 'src/app/models';
import { ArchiveService } from 'src/app/services/services/archive.service';
import { ArchiveType, RecordStatusType } from '../enums';
import { extAccessLog, extAccessSearchModel, recIdentifiers } from '../models';
import { DialogDeleteComponent } from 'src/app/common/dialogs/dialog-delete/dialog-delete.component';
import { MatDialog } from '@angular/material/dialog';
import { I18NextPipe } from 'angular-i18next';
import { EnvironmentService } from 'src/app/services/services/environmet.service';
import { Store } from '@ngrx/store';
import { State } from 'src/app/dashboards/state';
import { ErrorMessage, InfoMessage } from 'src/app/common/messages';
import * as mainActions from 'src/app/state/app.actions'
import { dynamicSort } from 'src/app/helpers/helpers';


@Component({
    selector: 'app-archive-external-access-logs',
    templateUrl: './archive-external-access-logs.component.html',
    styleUrls: ['./archive-external-access-logs.component.scss'],
    standalone: false
})
export class ArchiveExternalAccessLogsComponent implements OnInit {

  public searchModel: extAccessSearchModel = {
    username: '',
    recipientName: '',
    recipientEmail: '',
    type: 0,
    fromDate: moment().utcOffset(0).set({ hour: 0, minute: 0, second: 0 }).add(-1, 'days').toDate(),
    toDate: moment().utcOffset(0).set({ hour: 0, minute: 0, second: 0 }).add(-1, 'seconds').toDate()
  };
  public selectedData: any = { value: -1, selectedRange: 0 };
  public archiveTypes: property[] = [];
  public logs: extAccessLog[] = [];
  public dataLoaded: boolean = false;
  public statusType = RecordStatusType;
  public baseUrl: string;
  public logSort: string;

  constructor(private archiveService: ArchiveService,public dialog: MatDialog,private i18nextPipe: I18NextPipe,private store: Store<State>, ) { }

  ngOnInit(): void {
    this.archiveTypes = Object.keys(ArchiveType).map(key => ({ id: parseInt(key) , name: ArchiveType[key].toString() })).filter(x => !isNaN(x.id ));
    this.baseUrl = EnvironmentService.environment.baseUrl;
  }

  Search() {
    this.archiveService.extAccessSearchLog(this.searchModel).subscribe(data => {
      this.logs = data;
      this.logSort="";
      this.sortLogs("-date");
      this.dataLoaded = true;
    });
  }

  sortLogs(sort: string) {
    this.logSort = this.logSort == sort? `-${sort}` : sort;
    let innerProperty = sort == "recordings" ? "callId" : null;
    this.logs = this.logs.sort(dynamicSort(this.logSort,innerProperty));
  }

  setPeriod($event) {
    this.searchModel.fromDate = $event.from;
    this.searchModel.toDate = $event.to;
  }

  cancelEXtShare(id: number,recipient:string,recordings:recIdentifiers[]) {
    const dialogRef = this.dialog.open(DialogDeleteComponent, {
      disableClose: true,
      data: {
        title: this.i18nextPipe.transform('archive:Do you want to remove the access given to the recording(s)?'),
        additionalText: this.i18nextPipe.transform('archive:If you confirm, the recordings will not be accessible on the link distributed in the email/sms. Remove access?'),
        confirmText: this.i18nextPipe.transform('Yes'),
        cancelText: this.i18nextPipe.transform('No'),
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var recordingList = recordings.map(x => `${x.sessionId}_${x.index}`);
        this.archiveService.cancelExtAccess(id, recipient, recordingList).subscribe(data => {
          if (data) {
            this.Search();
            this.store.dispatch(
              mainActions.addMessage({
                message: new InfoMessage(
                  this.i18nextPipe.transform('messages:Share has been successfully canceled.'), "")
              }));
          } else {
            this.store.dispatch(
              mainActions.addMessage({
                message: new ErrorMessage(
                  this.i18nextPipe.transform('messages:Unable to cancel the share.'),
                  this.i18nextPipe.transform("messages:Please try again later."))
              }));
          }
        });
      }
    });


   }


}
